import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Homepage from "./pages/Homepage";
import "./App.css";
import Projects from "./pages/Projects";
import Videopage from "./pages/Videopage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage />}></Route>
        <Route path="/Projects" element={<Projects />}></Route>
        <Route path="/Video" element={<Videopage />}></Route>
      </Routes>
    </Router>
  );
}

export default App;
